import { APEX_API_URL } from '@/constants';
import { getAxiosInstance } from '@/utils/axios-instance';

export const getAllTicketLists = async (): Promise<any> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/ticket/categories`);
  return response.data;
};
